export default function TrustSection() {
  const trustItems = [
    {
      icon: 'ri-refresh-line',
      title: 'Updated Weekly',
      desc: 'Fresh trending products from China added every seven days to keep your sourcing pipeline full.',
    },
    {
      icon: 'ri-store-3-line',
      title: 'Shopify & Amazon Ready',
      desc: 'Designed for Shopify, Amazon, and TikTok Shop sellers who need reliable supplier data.',
    },
    {
      icon: 'ri-speed-up-line',
      title: '70% Faster Sourcing',
      desc: 'Cut product research time dramatically with pre-vetted, structured spreadsheet data.',
    },
    {
      icon: 'ri-funds-line',
      title: 'High-Margin Focus',
      desc: 'Every product in the spreadsheet is screened for profit potential before inclusion.',
    },
  ];

  return (
    <section className="relative py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 border border-accent-300/60 rounded-full text-sm font-medium text-accent-700 bg-accent-100/80 mb-6 whitespace-nowrap">
            Updated Weekly · 2,000+ Products · 30+ Categories
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-6">
            Why Thousands of Sellers
            <br />
            Use <span className="text-primary-500">AllChinaBuySpreadsheet</span>
          </h2>
          <p className="text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            AllChinaBuySpreadsheet is a structured sourcing system that helps ecommerce sellers
            discover profitable products from China suppliers using organized spreadsheets.
            Instead of manually searching platforms like 1688 or Alibaba, users access curated,
            updated product data in one place.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {trustItems.map((item, idx) => (
            <div
              key={idx}
              className="group p-6 md:p-8 rounded-xl bg-background-100 border border-background-200/70 hover:border-accent-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100/80 mb-5">
                <i className={`${item.icon} text-accent-600 text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-950 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}